import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Avatar, Dropdown, message, Input, Image, Tooltip } from "antd";
import NotificationIcon from "../../Assets/layout/notification.svg";
import { MenuOutlined, StarFilled } from "@ant-design/icons";
import Lefticon from "../../Assets/leftIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import Notification from "../common/notification/Notification";
import ChangePassword from "./changePasswordModal";
import LogoutModal from "./LogoutModal";
import SwitchAccount from "../common/SwitchAccount";
import API_MANAGER from "../../API";
import SearchIcon from "../../Assets/user_mangement/searchIcon.svg";
import CancelIcon from "../../Assets/cancelIcon.svg";
import SearchModal from "../common/search/SearchModal";
import MobileMenu from "./mobileMenu";
import StarIcon from "../../Assets/star.svg"

import Logo from "../../Assets/login/Logo.svg";

function SubLayout({
  page,
  whiteBg,
  children,
  padding,
  showBack,
  showSearch,
  backUrlFunction,
  isBackFunc,
  collapsed,
  currentPage,
  flow
  // setCollapsed
}) {
  // will comment later
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewAllState, setviewAllState] = useState(false);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const [switchAccountModal, setSwitchAccountModal] = useState(false);
  const [notifications, setNotifications] = useState();
  const [unReadCount, setUnReadCount] = useState(0);
  const [user, setUser] = useState(() => localStorage.getItem("user") || "");
  const [searchedData, setSearchedData] = useState({});
  const [searchText, setSearchText] = useState(null);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [searchType, setSearchType] = useState("all");
  const [showMenu, setShowMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [dataChange, setDataChange] = useState(false);
  const [hasOwnerAccount, setHasOwnerAccount] = useState(false);

  const updateCreateAccountAccess = (accounts = []) => {
    const list = Array.isArray(accounts) ? accounts : [];
    const hasOwner = list.some((item) => {
      const isOwner = item?.isOwner;
      return isOwner === true || isOwner === "true";
    });
    setHasOwnerAccount(hasOwner);
  };

  const checkCreateAccountAccess = async () => {
    try {
      const response = await API_MANAGER.getSwitchUserList();
      const accounts = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];
      updateCreateAccountAccess(accounts);
    } catch (error) {}
  };

  useEffect(() => {
    checkCreateAccountAccess();
  }, []);

  const getNotification = async () => {
    try {
      const response = await API_MANAGER.getNotification();
      setNotifications(response?.data?.data);
      let count = 0;
      response?.data?.data?.map((item) => {
        if (item?.isRead === false) {
          count = count + 1;
        }
      });
      setUnReadCount(count);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };
  const handleChangePassword = () => {
    setChangePasswordModal(true);
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleSwitchAccount = () => {
    setSwitchAccountModal(true);
  };
  const location = useLocation();
  const navigate = useNavigate();
  const [userName, setUserName] = useState(
    () => localStorage.getItem("name") || "John Doe"
  );
  const [logoutModal, setLogoutModal] = useState(false);

  let clientId = localStorage.getItem("clientId");

  const handleBack = () => {
    if (isBackFunc) {
      backUrlFunction();
    } else {
      // Global back - clear pagination sessionStorage
      // Check current pathname to determine which pagination keys to clear
      const pathname = location.pathname;
      
      // Clear AdvertDetail pagination
      if (pathname.includes('/advert-detail/')) {
        const advertId = pathname.split('/advert-detail/')[1]?.split('/')[0];
        console.log(advertId,"ADVRTIDD");
        if (advertId) {
          
          // Set flag FIRST to prevent any storage operations from restoring the value
          sessionStorage.setItem(`advertPageCleared_${advertId}`, 'true');
          // Clear pagination and search from sessionStorage
          sessionStorage.removeItem(`advertPage_${advertId}`);
          sessionStorage.removeItem(`advertSearch_${advertId}`);
          // Force clear again immediately to ensure it's removed
          sessionStorage.removeItem(`advertPage_${advertId}`);
          sessionStorage.removeItem(`advertSearch_${advertId}`);
        }
      }
      
      // Clear TrackerHistory pagination
      if (pathname.includes('/advert-tracker/')) {
        const trackerId = pathname.split('/advert-tracker/')[1]?.split('/')[0];
        if (trackerId) {
          // Clear all tab types
          ['HARD_REQUIREMENTS', 'SOFT_REQUIREMENTS', 'NOTES'].forEach(tabType => {
            sessionStorage.removeItem(`trackerPage_${trackerId}_${tabType}`);
          });
          sessionStorage.removeItem(`trackerSearch_${trackerId}`);
          sessionStorage.removeItem(`trackerFilter_${trackerId}`);
        }
      }
      
      navigate(-1);
    }
  };
  useEffect(() => {
    if (clientId !== "undefined") {
      getNotification();
    }
  }, [dataChange]);
  useEffect(() => {
    const syncHeaderUser = () => {
      setUserName(localStorage.getItem("name") || "John Doe");
      setUser(localStorage.getItem("user") || "");
    };
    syncHeaderUser();
    window.addEventListener("userNameChanged", syncHeaderUser);
    window.addEventListener("userTypeChanged", syncHeaderUser);
    window.addEventListener("storage", syncHeaderUser);
    return () => {
      window.removeEventListener("userNameChanged", syncHeaderUser);
      window.removeEventListener("userTypeChanged", syncHeaderUser);
      window.removeEventListener("storage", syncHeaderUser);
    };
  }, []);
  const handleLogout = () => {
    setLogoutModal(true);
  };
  useEffect(()=>{
    
  },[])

  const GetGlobalSearch = async (value) => {
    setSearchedData({});
    try {
      const param = {
        search: searchText,
        limit: 10,
        type: searchType,
      };
      const response = await API_MANAGER.getGlobalSearch(param);
      setSearchedData(response?.data?.data);
    } catch (err) {
      message.error("Something went wrong.");
    }
  };

  useEffect(() => {
    if (isLoggedOut) {
      const Email = localStorage.getItem("email");
      const Password = localStorage.getItem("password");
      localStorage.clear();
      if (Email && Password) {
        localStorage.setItem("email", Email);
        localStorage.setItem("password", Password);
      }
      navigate("/login");
    }
  }, [isLoggedOut]);
  const renderProfileDropdown = () => {
    return (
      <div className="actionDropdown ant-dropdown-menu">
        <div
          className="item"
          onClick={() => navigate(`/myProfile`)}
        >
          My Profile
        </div>
        <div className="item" onClick={() => handleChangePassword()}>
          Change Password
        </div>
        <div className="item" onClick={() => handleSwitchAccount()}>
          Switch Account
        </div>
        {!hasOwnerAccount && (
          <div className="item" onClick={() => navigate("/create-account")}>
            Create a new account
          </div>
        )}
        <div className="item logOutItem" onClick={() => handleLogout()}>
          Log Out
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (searchText && searchText?.length > 0) {
      GetGlobalSearch();
    }
    if (searchText?.length === 0) {
      setSearchedData({});
    }
  }, [searchType, searchText]);
  const handleEnterButton = () => {
    GetGlobalSearch();
  };
  return (
    <div
      className={
        localStorage?.getItem("Collapsable") === "true"
          ? "contentMainContainerCollapsable"
          : "contentMainContainer"
      }
    >
      <ChangePassword
        changePasswordModal={changePasswordModal}
        setChangePasswordModal={setChangePasswordModal}
      />
      <LogoutModal
        logoutModal={logoutModal}
        setLogoutModal={setLogoutModal}
        setIsLoggedOut={setIsLoggedOut}
      />
      {/* Switch account for associate users only */}
      <SwitchAccount
        switchAccountModal={switchAccountModal}
        setSwitchAccountModal={setSwitchAccountModal}
        onAccountsLoaded={updateCreateAccountAccess}
      />
      <div className="main-header">
        <Row justify={"space-between"} align={"middle"} className="navbar">
          <Col span={8}>
            <Row align={"top"}>
              <Col className="pageTitle">
                <Row align={"middle"}>
                  {localStorage.getItem("LogoRender")==="true" && (
                    <img
                      src={Logo}
                      alt="logo"
                      className="cursor-pointer"
                      style={{ marginRight: "10px" }}
                       onClick={() => navigate("/campaign-management")}
                    />
                  )}
                  {showBack && (
                    <Col>
                      <img
                        className="cursor-pointer"
                        src={Lefticon}
                        style={{ color: "white", marginRight: "5px" }}
                        onClick={handleBack}
                      />
                    </Col>
                  )}
                  <Col className="headerMainTitle">{page}</Col>
                </Row>
              </Col>
            </Row>
          </Col>
          {showSearch && (
            <Col span={7} className="align_items_center">
              <Input
                className="header_input_box_search"
                placeholder="Search name, email or discipline!"
                // onChange={(e) => setSearchText(e.target.value)}
                value={searchText}
                prefix={<img src={SearchIcon} className="search_icon" />}
                suffix={
                  searchText?.length !== 0 &&
                  searchText !== null && (
                    <img
                      className="cursor_pointer"
                      src={CancelIcon}
                      onClick={() => setSearchText(null)}
                    />
                  )
                }
                onClick={() => {
                  setIsSearchModalOpen(true);
                  // GetGlobalSearch();
                }}
              />
            </Col>
          )}
          {/* Right Side Section */}
          <Col span={9} className="justify_items_end">
            <Row align={"middle mr-30"}>
              <Col>
                {location.pathname === "/onboarding" ? (
                  <Row align={"middle"} className="user-decs">
                    <Col className="avatar-container">
                      <Avatar
                        size={36}
                        icon=<span className="profileAvatarName">
                          {userName ? userName[0] : "R"}
                        </span>
                      />
                    </Col>
                    <Col>
                      <p className="profileName">
                        {userName ? userName : "User"}
                      </p>
                      <p className="designation">Admin</p>
                    </Col>
                  </Row>
                ) : (
                  <Row align={"middle"} className="user-decs">
                    <Col className="avatar-container">
                      <Dropdown
                        placement="bottom"
                        overlayStyle={{ zIndex: 99999 }}
                        overlayClassName="profileDropdown"
                        trigger={["click"]}
                        destroyPopupOnHide
                        dropdownRender={renderProfileDropdown}
                        onOpenChange={(open) => {
                          if (open) {
                            checkCreateAccountAccess();
                          }
                        }}
                      >
                        <Avatar
                          size={36}
                          className="cursor-pointer"
                          icon=<span className="profileAvatarName">
                            {userName ? userName[0] : "R"}
                          </span>
                        />
                      </Dropdown>
                    </Col>
                    <Col className="header-name-col">
                      <p className="profileName text_capitalize">
                        {userName ? userName : "User"}
                      </p>
                      <p className="designation">
                        {user === "Root"
                          ? "Admin"
                          : user === "Associate"
                          ? "Association"
                          : user === "Account"
                          ? "Standard"
                          : user}
                      </p>
                    </Col>
                    <Tooltip title="Favourites">
                    <Col className="header-star-col">
                     <span
                       className="cursor-pointer"
                       onClick={() => navigate('/search?tab=favourites')}
                       style={{ display: 'inline-flex' }}
                     >
                    <img src={StarIcon} height={24} width={24}/>


                     </span>
                    </Col>
                    </Tooltip>
                    <Col
                      className="ml-60 cursor_pointer"
                      style={{ position: "relative" }}
                      onClick={() => {
                        setIsMobile(false);
                        showModal();
                      }}
                    >
                      {unReadCount > 0 && (
                        <div
                          style={{
                            position: "absolute",
                            color: "#fff",
                            borderRadius: "50%",
                            height: "27px",
                            width: "27px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#D03C28",
                            top: "-15px",
                            right: "-15px",
                          }}
                        >
                          {unReadCount < 100 ? unReadCount : `99+`}
                        </div>
                      )}

                      <img src={NotificationIcon} />
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      {/* navbar for mobile screen */}
      <div className="mobile_navbar_parents">
        <Row
          align={"middle"}
          justify={"space-between"}
          className="mobile_navbar"
        >
          <Col className="mobile-logo">
            {/* <img
              src={Logo}
              onClick={() => navigate("/campaign-management")}
              alt="logo"
              className="mobile-nav-logo"
            /> */}
            <svg
              width="165"
              className="mobile-nav-logo"
              height="35"
              viewBox="0 0 165 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => navigate("/campaign-management")}
            >
              <path
                d="M16.5399 12.7308C16.5399 14.2886 16.7346 15.7548 17.1241 17.1236C17.5135 18.4981 18.1034 19.6893 18.888 20.703C19.6727 21.7168 20.6635 22.5128 21.849 23.0913C23.0345 23.6697 24.3174 23.9561 25.6977 23.9561C26.5396 23.9561 27.3643 23.8415 28.1661 23.6125C28.9679 23.3834 29.6781 22.9939 30.2966 22.4441C30.8808 21.9229 31.3905 21.2872 31.82 20.5312C32.2496 19.7752 32.6734 18.8875 33.0972 17.8681L34.1682 18.1086C33.8933 19.1796 33.6756 20.1876 33.5095 21.1269C33.3492 22.0661 33.2117 23.0741 33.0972 24.1451C31.7799 24.5174 30.497 24.8094 29.2371 25.0213C27.9771 25.2332 26.7171 25.3363 25.4514 25.3363C23.5042 25.3363 21.7574 25.05 20.2053 24.483C18.6532 23.916 17.3188 23.1142 16.1905 22.0718C15.0623 21.0352 14.1803 19.781 13.5503 18.3091C12.9146 16.8429 12.5996 15.205 12.5996 13.4009C12.5996 11.3219 12.9833 9.51214 13.745 7.96008C14.5068 6.40801 15.5434 5.11367 16.8492 4.07705C18.155 3.04043 19.6669 2.26154 21.3908 1.75182C23.109 1.2421 24.9875 0.984375 27.0149 0.984375C28.0057 0.984375 29.0652 1.05883 30.1935 1.20201C31.3218 1.34519 32.387 1.55137 33.395 1.80909C33.2976 2.84571 33.2346 3.83651 33.2117 4.76431C33.1888 5.69784 33.1774 6.68292 33.1774 7.72526L32.0548 7.82263C31.9918 6.86619 31.7971 6.03575 31.4821 5.32558C31.1671 4.61541 30.7433 4.03696 30.2164 3.57306C29.6895 3.10916 29.0767 2.77698 28.378 2.57653C27.6793 2.37608 26.9347 2.27299 26.1387 2.27299C24.7412 2.27299 23.4297 2.51926 22.1926 3.01752C20.9613 3.51006 19.9247 4.22023 19.0885 5.13658C18.2523 6.05293 17.6166 7.15827 17.1871 8.44689C16.7575 9.7355 16.5399 11.1616 16.5399 12.7194V12.7308Z"
                fill="white"
              />
              <path
                d="M43.0165 24.8554C42.4953 24.8554 41.8711 24.8497 41.1437 24.8325C40.4106 24.8153 39.5688 24.8096 38.6123 24.8096C37.8162 24.8096 37.1175 24.8153 36.5162 24.8325C35.9148 24.8497 35.3879 24.8554 34.9355 24.8554L34.8896 24.0249C35.428 23.9791 35.8518 23.9047 36.1668 23.8188C36.4818 23.7271 36.7281 23.5782 36.9113 23.3663C37.0889 23.1544 37.2092 22.868 37.2664 22.5015C37.3237 22.135 37.3523 21.6482 37.3523 21.0296V14.724C37.3523 14.2716 37.3294 13.9107 37.2779 13.653C37.2321 13.3953 37.129 13.1891 36.9743 13.0459C36.8197 12.897 36.5906 12.7882 36.2928 12.7023C35.995 12.6221 35.5998 12.5419 35.113 12.456L35.0386 11.7001C35.5425 11.6027 36.0465 11.4996 36.562 11.3965C37.0717 11.2934 37.6387 11.1789 38.2515 11.0701C38.8643 10.9612 39.3511 10.8524 39.7005 10.7551C40.0498 10.6577 40.3133 10.5661 40.4908 10.4859L40.7314 10.6806C40.6856 11.0872 40.6397 11.5225 40.6111 11.9979C40.5767 12.4675 40.5538 12.9257 40.5366 13.3724C40.5195 13.8191 40.508 14.2429 40.5023 14.6381C40.4966 15.0333 40.4908 15.3826 40.4908 15.6747V22.0319C40.4908 22.4213 40.5137 22.7363 40.5653 22.9711C40.6111 23.206 40.7256 23.3892 40.8917 23.5209C41.0635 23.6527 41.3155 23.7386 41.6592 23.7901C42.0028 23.8359 42.4724 23.8818 43.0738 23.9104L43.028 24.8611L43.0165 24.8554ZM37.0774 4.6499C37.0774 4.11154 37.2378 3.682 37.5642 3.34983C37.8907 3.01765 38.3202 2.85156 38.8529 2.85156C39.4198 2.85156 39.8723 3.01765 40.2045 3.34983C40.5366 3.682 40.7027 4.11727 40.7027 4.6499C40.7027 5.18252 40.5366 5.61779 40.2045 5.94997C39.8723 6.28214 39.4198 6.44823 38.8529 6.44823C38.3202 6.44823 37.885 6.28214 37.5642 5.94997C37.2378 5.61779 37.0774 5.18252 37.0774 4.6499Z"
                fill="white"
              />
              <path
                d="M51.4298 24.8536C50.9087 24.8536 50.3245 24.8479 49.6773 24.8307C49.0302 24.8135 48.1997 24.8078 47.1917 24.8078C46.4472 24.8078 45.7599 24.8135 45.1357 24.8307C44.5114 24.8479 43.9731 24.8536 43.5149 24.8536L43.4404 24.0232C43.9902 23.9773 44.437 23.9029 44.7691 23.8055C45.1013 23.7082 45.359 23.5593 45.548 23.3531C45.737 23.1526 45.8573 22.8663 45.9146 22.4997C45.9718 22.1332 46.0005 21.6464 46.0005 21.0278V14.8196C46.0005 14.3671 45.9776 14.0063 45.926 13.7486C45.8802 13.4909 45.7771 13.2847 45.6225 13.1301C45.4678 12.9754 45.2388 12.8609 44.941 12.775C44.6431 12.6948 44.248 12.6146 43.7612 12.5287L43.6867 11.7956C44.0933 11.7155 44.563 11.6181 45.1013 11.5035C45.6397 11.389 46.1379 11.2745 46.5961 11.1485C47.06 11.0282 47.501 10.9079 47.9248 10.7934C48.3486 10.6788 48.6808 10.5757 48.9213 10.4784L49.3108 10.6731C49.265 11.0167 49.2192 11.3489 49.1905 11.6811C49.1562 12.0133 49.1447 12.3512 49.1447 12.6891C49.958 11.9904 50.8113 11.4463 51.7162 11.0568C52.6154 10.6674 53.5145 10.4727 54.408 10.4727C55.0265 10.4727 55.5992 10.5643 56.1261 10.7533C56.653 10.9423 57.1169 11.2344 57.5121 11.641C57.9073 12.0476 58.2165 12.5631 58.4399 13.1873C58.6575 13.8116 58.7664 14.5733 58.7664 15.4668V22.0186C58.7664 22.4081 58.7893 22.7231 58.8408 22.9579C58.8866 23.1927 58.9897 23.376 59.1444 23.5077C59.299 23.6394 59.5281 23.7253 59.8373 23.7769C60.1466 23.8227 60.559 23.8685 61.0801 23.8972L61.0343 24.8479C60.5131 24.8479 59.9404 24.8421 59.3162 24.825C58.6919 24.8078 57.9302 24.8021 57.0425 24.8021C56.1548 24.8021 55.4618 24.8078 54.8891 24.825C54.3106 24.8421 53.7952 24.8479 53.3427 24.8479L53.2683 24.0174C53.7723 23.9716 54.1789 23.9029 54.4824 23.8227C54.7917 23.7425 55.0265 23.6051 55.1869 23.4218C55.3472 23.2328 55.456 22.9694 55.5019 22.62C55.5477 22.2706 55.5763 21.7896 55.5763 21.171V16.1827C55.5763 14.8826 55.3243 13.9491 54.8203 13.3706C54.3163 12.7922 53.6692 12.5058 52.8731 12.5058C52.1572 12.5058 51.51 12.6318 50.9259 12.8838C50.3417 13.1358 49.7461 13.4909 49.1504 13.9433V22.0244C49.1504 22.4138 49.1733 22.7288 49.2134 22.9636C49.2535 23.1984 49.3566 23.3817 49.517 23.5134C49.6773 23.6452 49.9179 23.7311 50.2329 23.7826C50.5479 23.8342 50.9774 23.8743 51.51 23.9029L51.4356 24.8536H51.4298Z"
                fill="white"
              />
              <path
                d="M73.1415 21.7175C72.8322 22.3188 72.4599 22.84 72.0189 23.2752C71.5779 23.7162 71.0969 24.0885 70.57 24.3978C70.0431 24.707 69.4875 24.9419 68.9034 25.1022C68.3192 25.2626 67.735 25.3428 67.1508 25.3428C66.0627 25.3428 65.112 25.1538 64.3044 24.77C63.4912 24.3863 62.7925 23.8823 62.2083 23.2466C61.6241 22.6109 61.1717 21.8778 60.8452 21.0416C60.5188 20.2055 60.3584 19.3235 60.3584 18.4014C60.3584 17.2789 60.5818 16.2423 61.0285 15.2858C61.4752 14.3294 62.0766 13.4932 62.8325 12.7773C63.5885 12.0614 64.4591 11.5059 65.4499 11.0993C66.4407 10.6926 67.546 10.4922 68.7602 10.4922C69.3443 10.4922 69.9228 10.5323 70.5012 10.6125C71.0797 10.6926 71.6238 10.8702 72.1449 11.1508C72.374 11.2654 72.5287 11.4143 72.6203 11.6033C72.7119 11.7923 72.752 11.987 72.752 12.1989C72.752 12.491 72.6375 12.8117 72.4084 13.1611C72.1793 13.5104 71.7498 13.814 71.1198 14.0717H70.9995C70.3981 13.4531 69.8197 13.0007 69.2699 12.7086C68.7201 12.4165 68.0786 12.2676 67.3456 12.2676C66.8072 12.2676 66.3089 12.3993 65.8336 12.6685C65.364 12.9377 64.9573 13.2985 64.6194 13.751C64.2758 14.2034 64.0181 14.7188 63.8405 15.2858C63.663 15.8528 63.5713 16.4542 63.5713 17.0899C63.5713 17.886 63.6802 18.6362 63.8978 19.3407C64.1154 20.0451 64.4361 20.6751 64.86 21.2249C65.2838 21.7747 65.8107 22.2157 66.4407 22.5422C67.0764 22.8686 67.7293 23.029 68.4108 23.029C69.1897 23.029 69.9342 22.8686 70.6501 22.5422C71.366 22.2157 71.9388 21.7117 72.3797 21.0302L73.1357 21.7117L73.1415 21.7175Z"
                fill="white"
              />
              <path
                d="M78.9087 0.194724C78.8457 0.601354 78.7884 1.08244 78.7368 1.63225C78.691 2.18205 78.6509 2.73759 78.628 3.2874C78.6051 3.83721 78.5879 4.35838 78.5765 4.84519C78.5708 5.332 78.565 5.72145 78.565 6.01354V12.4165C79.3955 11.8495 80.2316 11.3856 81.085 11.0305C81.9383 10.6755 82.8318 10.4922 83.7768 10.4922C84.4755 10.4922 85.0825 10.5838 85.6037 10.7614C86.1249 10.9389 86.5773 11.2253 86.9668 11.6262C87.3562 12.0213 87.6655 12.5425 87.8946 13.184C88.1237 13.8254 88.2325 14.61 88.2325 15.5321V22.0325C88.2325 22.4219 88.2554 22.7369 88.2955 22.9717C88.3356 23.2065 88.4387 23.3898 88.599 23.5215C88.7594 23.6532 89.0057 23.7392 89.3321 23.7907C89.6586 23.8365 90.0938 23.8823 90.6494 23.911L90.6036 24.8617C90.0824 24.8617 89.4867 24.856 88.8167 24.8388C88.1409 24.8216 87.362 24.8159 86.4685 24.8159C85.5751 24.8159 84.8936 24.8216 84.3266 24.8388C83.7596 24.856 83.2499 24.8617 82.7917 24.8617L82.7172 24.0312C83.2212 23.9854 83.6278 23.9167 83.9486 23.8365C84.2636 23.7563 84.5098 23.6189 84.6816 23.4356C84.8535 23.2466 84.968 22.9832 85.0196 22.6338C85.0768 22.2844 85.1055 21.8034 85.1055 21.1848V16.1965C85.1055 14.8792 84.842 13.94 84.3151 13.373C83.7882 12.806 83.1181 12.5196 82.3049 12.5196C81.6577 12.5196 81.0449 12.6433 80.4779 12.8953C79.9109 13.1472 79.2752 13.5023 78.5765 13.9548V22.0358C78.5765 22.4253 78.5994 22.7403 78.6509 22.9751C78.6967 23.2123 78.8056 23.3955 78.9659 23.5272C79.1263 23.659 79.3668 23.7425 79.6818 23.7941C79.9968 23.8456 80.4264 23.8857 80.959 23.9143L80.8845 24.8674C80.3634 24.8674 79.7849 24.8617 79.1435 24.8445C78.502 24.8273 77.6773 24.8216 76.6693 24.8216C75.9248 24.8216 75.249 24.8273 74.6476 24.8445C74.0463 24.8617 73.5194 24.8674 73.0669 24.8674L73.0211 24.037C73.5537 23.9911 73.9833 23.9167 74.2983 23.8193C74.6133 23.722 74.8595 23.5731 75.0428 23.3669C75.2204 23.1664 75.3406 22.8801 75.3979 22.5135C75.4552 22.147 75.4838 21.6602 75.4838 21.0417V4.46147C75.4838 3.99184 75.4552 3.61958 75.3979 3.35613C75.3406 3.08695 75.2261 2.88077 75.06 2.73759C74.8882 2.58868 74.6362 2.47987 74.2925 2.39396C73.9546 2.31378 73.5022 2.22214 72.9524 2.12478L72.8779 1.3688C73.3304 1.28861 73.8172 1.19125 74.3269 1.07671C74.8366 0.962165 75.3578 0.847622 75.8847 0.721625C76.4116 0.601354 76.9328 0.475356 77.4539 0.343631C77.9751 0.211906 78.3703 0.097362 78.6452 0L78.9144 0.194724H78.9087Z"
                fill="white"
              />
              <path
                d="M106.216 11.7799C105.729 11.8429 105.34 11.9174 105.048 11.9976C104.756 12.0777 104.498 12.198 104.28 12.3641C104.063 12.5245 103.862 12.7478 103.685 13.0342C103.507 13.3205 103.295 13.7043 103.055 14.1911C102.682 14.9356 102.276 15.8004 101.835 16.7855C101.394 17.7706 100.947 18.8129 100.483 19.9125C100.019 21.0121 99.5552 22.1576 99.0856 23.3316C98.616 24.5114 98.1578 25.6626 97.7225 26.8023C97.3961 27.5984 97.1613 28.1711 97.0181 28.5205C96.8749 28.8698 96.6115 29.4196 96.2392 30.1642C95.8669 30.9087 95.4832 31.5788 95.0938 32.1744C94.7043 32.7643 94.3149 33.2167 93.9254 33.526C93.1122 34.2076 92.2588 34.5512 91.3711 34.5512C90.8671 34.5512 90.4605 34.4195 90.1397 34.1617C89.8248 33.904 89.6644 33.5432 89.6644 33.0908C89.6644 32.6383 89.7675 32.2489 89.9679 31.9854C90.1684 31.7162 90.4318 31.4929 90.7583 31.3153C91.016 31.3955 91.2222 31.4471 91.3654 31.4757C91.5086 31.5043 91.6517 31.5101 91.7777 31.5101C92.15 31.5101 92.5108 31.4585 92.8487 31.3497C93.1923 31.2466 93.4901 31.0633 93.7479 30.7999C94.3492 30.1813 94.9048 29.3738 95.4145 28.3658C95.9242 27.3578 96.2621 26.6019 96.4225 26.1036L96.4683 25.9833L96.2507 25.3247C95.9242 24.4484 95.5748 23.5206 95.2026 22.547C94.8303 21.5734 94.4523 20.5998 94.0686 19.6262C93.6849 18.6525 93.3069 17.7018 92.9232 16.7798C92.5394 15.8519 92.1786 14.9929 91.8407 14.1968C91.6288 13.71 91.4398 13.3205 91.268 13.0284C91.0962 12.7364 90.9015 12.5187 90.6838 12.3698C90.4662 12.2209 90.2028 12.1178 89.9049 12.0548C89.6071 11.9918 89.2177 11.9403 88.748 11.9116L88.7939 10.9609C89.3322 10.9609 89.9278 10.9667 90.5979 10.9838C91.2623 11.001 92.0412 11.0068 92.9346 11.0068C93.7479 11.0068 94.418 11.001 94.9449 10.9838C95.4718 10.9667 95.97 10.9609 96.4396 10.9609L96.4855 11.8143C95.8383 11.8945 95.3801 11.9918 95.1224 12.1064C94.8647 12.2209 94.7329 12.3985 94.7329 12.6447C94.7329 12.7765 94.7616 12.9311 94.8189 13.1201C94.8761 13.3091 94.9449 13.5153 95.025 13.7386L98.1177 21.8712L101.548 13.6928C101.726 13.1258 101.817 12.7994 101.817 12.7192C101.817 12.4271 101.68 12.2152 101.405 12.0835C101.13 11.9517 100.626 11.8716 99.8931 11.8429L99.9389 10.9667C100.443 10.9667 100.935 10.9724 101.422 10.9896C101.909 11.0068 102.528 11.0125 103.272 11.0125C103.908 11.0125 104.441 11.0068 104.882 10.9896C105.317 10.9724 105.741 10.9667 106.147 10.9667L106.193 11.7971L106.216 11.7799Z"
                fill="white"
              />
              <path
                d="M110.728 21.3012C110.728 21.8453 110.625 22.3665 110.413 22.8647C110.207 23.363 109.921 23.7983 109.571 24.1648C109.216 24.5313 108.798 24.8234 108.323 25.0296C107.842 25.2358 107.344 25.3446 106.834 25.3446C106.29 25.3446 105.78 25.2415 105.316 25.0296C104.852 24.8234 104.44 24.5313 104.09 24.1648C103.741 23.7983 103.455 23.363 103.249 22.8647C103.042 22.3665 102.934 21.8453 102.934 21.3012C102.934 20.7571 103.037 20.2359 103.249 19.7377C103.455 19.2394 103.735 18.8099 104.09 18.4376C104.446 18.0711 104.852 17.779 105.316 17.5728C105.78 17.3666 106.284 17.2578 106.834 17.2578C107.349 17.2578 107.842 17.3609 108.323 17.5728C108.804 17.779 109.222 18.0711 109.571 18.4376C109.926 18.8042 110.207 19.2394 110.413 19.7377C110.619 20.2359 110.728 20.7571 110.728 21.3012Z"
                fill="#FCC009"
              />
              <path
                d="M120.517 24.8536C119.996 24.8536 119.412 24.8479 118.764 24.8307C118.117 24.8135 117.401 24.8078 116.622 24.8078C115.844 24.8078 115.191 24.8135 114.566 24.8307C113.942 24.8479 113.404 24.8536 112.946 24.8536L112.871 24.0232C113.421 23.9773 113.868 23.9029 114.2 23.8055C114.532 23.7082 114.79 23.5593 114.979 23.3531C115.168 23.1526 115.288 22.8663 115.345 22.4997C115.403 22.1332 115.431 21.6464 115.431 21.0278V14.8196C115.431 14.3671 115.408 14.0063 115.357 13.7486C115.311 13.4909 115.208 13.2847 115.053 13.1301C114.899 12.9754 114.669 12.8609 114.372 12.775C114.074 12.6948 113.679 12.6146 113.192 12.5287L113.117 11.7956C113.524 11.7155 113.959 11.6238 114.417 11.515C114.881 11.4119 115.357 11.2916 115.855 11.1599C116.347 11.0282 116.788 10.9079 117.172 10.7934C117.556 10.6788 117.865 10.5757 118.111 10.4784L118.404 10.6731C118.358 11.0167 118.312 11.3489 118.283 11.6811C118.249 12.0133 118.237 12.3512 118.237 12.6891C119.079 11.9904 119.973 11.4463 120.918 11.0568C121.863 10.6674 122.762 10.4727 123.621 10.4727C124.549 10.4727 125.328 10.6731 125.969 11.0683C126.611 11.4635 127.092 12.1049 127.418 12.9812C128.346 12.1851 129.274 11.5665 130.207 11.1313C131.141 10.6903 132.08 10.4727 133.019 10.4727C133.684 10.4727 134.262 10.5643 134.76 10.7533C135.253 10.9423 135.682 11.2344 136.038 11.641C136.393 12.0476 136.679 12.5631 136.891 13.1873C137.103 13.8116 137.206 14.5733 137.206 15.4668V22.0186C137.206 22.4081 137.229 22.7231 137.28 22.9579C137.326 23.1927 137.429 23.376 137.584 23.5077C137.738 23.6394 137.968 23.7253 138.277 23.7769C138.586 23.8284 138.998 23.8685 139.52 23.8972L139.474 24.8479C138.953 24.8479 138.38 24.8421 137.756 24.825C137.131 24.8078 136.381 24.8021 135.505 24.8021C134.629 24.8021 133.924 24.8078 133.351 24.825C132.773 24.8421 132.258 24.8479 131.805 24.8479L131.731 24.0174C132.235 23.9716 132.641 23.9029 132.951 23.8227C133.26 23.7425 133.495 23.6051 133.655 23.4218C133.815 23.2328 133.924 22.9694 133.97 22.62C134.016 22.2706 134.044 21.7896 134.044 21.171V16.1827C134.044 14.8826 133.804 13.9491 133.311 13.3706C132.825 12.7922 132.218 12.5058 131.484 12.5058C130.883 12.5058 130.27 12.6433 129.646 12.9182C129.022 13.1931 128.369 13.5653 127.687 14.0407C127.722 14.2698 127.75 14.4989 127.773 14.7337C127.796 14.9685 127.808 15.2148 127.808 15.4782V22.0301C127.808 22.4195 127.83 22.7345 127.882 22.9694C127.928 23.2042 128.031 23.3874 128.186 23.5192C128.34 23.6509 128.569 23.7368 128.879 23.7883C129.188 23.8399 129.6 23.88 130.121 23.9086L130.076 24.8593C129.554 24.8593 128.982 24.8536 128.357 24.8364C127.733 24.8192 126.983 24.8135 126.107 24.8135C125.23 24.8135 124.526 24.8192 123.953 24.8364C123.375 24.8536 122.859 24.8593 122.407 24.8593L122.332 24.0289C122.836 23.9831 123.243 23.9143 123.547 23.8342C123.856 23.754 124.091 23.6165 124.251 23.4333C124.411 23.2443 124.52 22.9808 124.566 22.6315C124.612 22.2821 124.64 21.801 124.64 21.1825V16.1941C124.64 14.894 124.4 13.9605 123.907 13.3821C123.421 12.8036 122.813 12.5173 122.08 12.5173C121.513 12.5173 120.895 12.6433 120.231 12.8953C119.566 13.1472 118.902 13.5023 118.232 13.9548V22.0358C118.232 22.4253 118.255 22.7403 118.295 22.9751C118.335 23.2099 118.438 23.3932 118.598 23.5249C118.759 23.6566 118.999 23.7425 119.314 23.7941C119.629 23.8456 120.059 23.8857 120.591 23.9143L120.517 24.8651V24.8536Z"
                fill="white"
              />
              <path
                d="M152.102 22.1069C151.535 22.8228 150.973 23.3841 150.424 23.7964C149.874 24.2088 149.341 24.5295 148.843 24.7586C148.339 24.9877 147.875 25.1423 147.457 25.2225C147.033 25.3027 146.667 25.3428 146.363 25.3428C145.241 25.3428 144.261 25.1538 143.419 24.7815C142.577 24.4092 141.85 23.8995 141.243 23.2466C140.636 22.5994 140.166 21.8377 139.828 20.9729C139.496 20.1024 139.33 19.186 139.33 18.2067C139.33 17.1185 139.531 16.1105 139.926 15.177C140.321 14.2435 140.854 13.4302 141.506 12.7315C142.165 12.0328 142.921 11.4887 143.78 11.0878C144.639 10.6926 145.584 10.4922 146.604 10.4922C147.445 10.4922 148.201 10.6125 148.854 10.8473C149.513 11.0821 150.086 11.42 150.573 11.8553C151.059 12.2962 151.449 12.8231 151.741 13.436C152.033 14.0545 152.182 14.7418 152.182 15.5035V15.8471L152.159 16.185C152.079 16.626 151.85 16.8436 151.477 16.8436H142.446C142.463 17.9662 142.617 18.9111 142.921 19.69C143.225 20.4689 143.625 21.1046 144.141 21.5915C144.656 22.0783 145.218 22.4391 145.848 22.6739C146.472 22.9087 147.079 23.029 147.663 23.029C148.247 23.029 148.866 22.9144 149.467 22.6911C150.069 22.4677 150.699 22.0153 151.369 21.3509L152.125 22.1069H152.102ZM147.99 15.7497C148.316 15.7497 148.522 15.6867 148.62 15.5665C148.717 15.4462 148.768 15.24 148.768 14.9479C148.768 14.5069 148.705 14.106 148.574 13.728C148.442 13.3558 148.247 13.0293 147.978 12.7544C147.709 12.4795 147.4 12.2619 147.05 12.0958C146.701 11.9354 146.306 11.8553 145.871 11.8553C145.515 11.8553 145.149 11.9469 144.777 12.1244C144.404 12.302 144.066 12.554 143.769 12.8804C143.471 13.2069 143.207 13.6078 142.99 14.0831C142.772 14.5585 142.623 15.1197 142.537 15.7497H147.99Z"
                fill="white"
              />
              <path
                d="M4.54738 1.21322C4.1522 1.36213 3.78566 1.55685 3.45349 1.79739C3.12131 2.03794 2.84641 2.30139 2.62305 2.59347C2.39969 2.88556 2.22787 3.18337 2.10187 3.49837C1.97588 3.81336 1.91288 4.1169 1.91288 4.42044C1.91288 4.90153 2.08469 5.33106 2.43405 5.71479C2.78341 6.09851 3.31031 6.32187 4.02621 6.38486C4.20948 6.48223 4.33547 6.61968 4.40993 6.79722C4.48438 6.97476 4.52447 7.14085 4.52447 7.30694C4.52447 7.75366 4.35266 8.10874 4.01475 8.37792C3.67685 8.6471 3.2874 8.7731 2.85786 8.7731C2.42832 8.7731 2.03315 8.67574 1.67806 8.47529C1.32298 8.27483 1.01944 8.01711 0.773169 7.69066C0.526901 7.36994 0.332177 7.00913 0.200451 6.60822C0.0687264 6.20732 0 5.81215 0 5.41697C0 4.82135 0.114544 4.26008 0.337904 3.72745C0.561264 3.19483 0.870531 2.71947 1.25998 2.28421C1.64943 1.85467 2.09615 1.47095 2.60014 1.12732C3.10413 0.789412 3.63676 0.508781 4.20375 0.296875L4.55311 1.21895L4.54738 1.21322ZM10.6583 1.21322C10.2631 1.36213 9.89656 1.55685 9.56439 1.79739C9.23221 2.03794 8.95731 2.30139 8.73395 2.59347C8.51059 2.88556 8.33877 3.18337 8.21277 3.49837C8.08678 3.81336 8.02378 4.1169 8.02378 4.42044C8.02378 4.90153 8.19559 5.33106 8.54495 5.71479C8.89431 6.09851 9.42121 6.32187 10.1371 6.38486C10.3204 6.48223 10.4464 6.61968 10.5208 6.79722C10.5953 6.97476 10.6354 7.14085 10.6354 7.30694C10.6354 7.75366 10.4636 8.10874 10.1257 8.37792C9.78775 8.6471 9.3983 8.7731 8.96876 8.7731C8.53922 8.7731 8.14405 8.67574 7.78896 8.47529C7.43388 8.27483 7.13034 8.01711 6.88407 7.69066C6.6378 7.36994 6.44307 7.00913 6.31135 6.60822C6.17962 6.20732 6.1109 5.81215 6.1109 5.41697C6.1109 4.82135 6.21972 4.26008 6.44308 3.72745C6.66644 3.19483 6.9757 2.71947 7.36515 2.28421C7.7546 1.85467 8.20132 1.47095 8.70531 1.12732C9.2093 0.789412 9.74193 0.508781 10.3089 0.296875L10.6583 1.21895V1.21322Z"
                fill="white"
              />
              <path
                d="M154.312 7.9505C154.708 7.80159 155.074 7.60687 155.406 7.36633C155.738 7.12579 156.013 6.86234 156.237 6.57025C156.46 6.28389 156.632 5.98035 156.758 5.66536C156.884 5.35036 156.947 5.04682 156.947 4.74328C156.947 4.2622 156.775 3.83266 156.426 3.44894C156.076 3.06522 155.549 2.84186 154.834 2.77886C154.65 2.6815 154.524 2.54404 154.45 2.3665C154.375 2.19469 154.335 2.02287 154.335 1.85678C154.335 1.41006 154.507 1.05498 154.845 0.785801C155.183 0.52235 155.572 0.390625 156.002 0.390625C156.431 0.390625 156.827 0.487987 157.182 0.688439C157.537 0.88889 157.84 1.14661 158.087 1.47306C158.333 1.79378 158.528 2.1546 158.659 2.5555C158.791 2.9564 158.86 3.35158 158.86 3.74675C158.86 4.34238 158.745 4.90364 158.51 5.43627C158.276 5.9689 157.972 6.44998 157.588 6.89097C157.205 7.33196 156.764 7.71569 156.26 8.04786C155.756 8.38004 155.217 8.65494 154.656 8.86685L154.307 7.94477L154.312 7.9505ZM160.452 7.9505C160.847 7.80159 161.214 7.60687 161.546 7.36633C161.878 7.12579 162.153 6.86234 162.376 6.57025C162.6 6.28389 162.771 5.98035 162.897 5.66536C163.023 5.35036 163.086 5.04682 163.086 4.74328C163.086 4.2622 162.915 3.83266 162.565 3.44894C162.216 3.06522 161.689 2.84186 160.973 2.77886C160.79 2.6815 160.664 2.54404 160.589 2.3665C160.515 2.18896 160.475 2.02287 160.475 1.85678C160.475 1.41006 160.647 1.05498 160.985 0.785801C161.322 0.52235 161.706 0.390625 162.141 0.390625C162.577 0.390625 162.966 0.487987 163.321 0.688439C163.676 0.88889 163.98 1.14661 164.226 1.47306C164.472 1.79378 164.667 2.1546 164.799 2.5555C164.931 2.9564 164.999 3.35158 164.999 3.74675C164.999 4.34238 164.885 4.90364 164.65 5.43627C164.415 5.9689 164.112 6.44998 163.728 6.89097C163.344 7.33196 162.903 7.71569 162.399 8.04786C161.895 8.38004 161.357 8.65494 160.796 8.86685L160.446 7.94477L160.452 7.9505Z"
                fill="white"
              />
              <path
                d="M154.501 25.4773V23.49H153.757V23.2266H155.544V23.49H154.799V25.4773H154.501Z"
                fill="white"
              />
              <path
                d="M155.842 25.4792V23.2227H156.289L156.821 24.8205C156.873 24.9694 156.907 25.0783 156.93 25.1527C156.953 25.0725 156.999 24.9523 157.05 24.7919L157.589 23.2227H157.989V25.4792H157.703V23.5949L157.05 25.4792H156.781L156.128 23.5606V25.4792H155.842Z"
                fill="white"
              />
            </svg>
          </Col>
          <Col className="hamberger-icon">
            <MenuOutlined onClick={() => setShowMenu(!showMenu)} />
          </Col>
        </Row>
      </div>
      <Col
        className={
          localStorage?.getItem("Collapsable") === "true"
            ? "contentMainContainerCollapsable"
            : "contentMainContainer"
        }
      >
        <div
          className={
            !padding
              ? `mainContainer ${whiteBg ? "white-bg" : ""}`
              : "simpleMainContainer"
          }
        >
          {children}
        </div>
      </Col>

      <Notification
        showModal={showModal}
        handleOk={handleOk}
        handleCancel={handleCancel}
        isModalOpen={isModalOpen}
        setviewAllState={setviewAllState}
        viewAllState={viewAllState}
        notifications={notifications}
        isMobile={isMobile}
        setIsMobile={setIsMobile}
        setDataChange={setDataChange}
      />
      <SearchModal
        searchType={searchType}
        setSearchType={setSearchType}
        isSearchModalOpen={isSearchModalOpen}
        setIsSearchModalOpen={setIsSearchModalOpen}
        searchedData={searchedData}
        searchText={searchText}
        setSearchText={setSearchText}
        handleEnterButton={handleEnterButton}
      />
      {showMenu && (
        <MobileMenu
          showNotificationModal={showModal}
          setShowMenu={setShowMenu}
          setviewAllState={setviewAllState}
          showMenu={showMenu}
          setIsMobile={setIsMobile}
        />
      )}
    </div>
  );
}

export default SubLayout;
